import Tracker from "@openreplay/tracker";
import { readConfigValue, type AppConfig } from "config/config";

type OpenReplaySettings = {
  projectKey: string;
  ingestPoint: string;
};

type OpenReplayUserMetadata = {
  email: string;
  roles: string;
};

let openReplayTracker: Tracker | null = null;
let isOpenReplayStarted = false;
let latestOpenReplayMetadata: OpenReplayUserMetadata | null = null;

function readOpenReplaySettings(config: AppConfig): OpenReplaySettings | null {
  const projectKey = readConfigValue(config.openReplayProjectKey);
  const ingestPoint = readConfigValue(config.openReplayIngestPoint);

  if (projectKey === undefined || ingestPoint === undefined) {
    return null;
  }

  return { projectKey, ingestPoint };
}

function sendOpenReplayMetadata(): void {
  const metadata = latestOpenReplayMetadata;
  if (!isOpenReplayStarted || metadata === null) {
    return;
  }

  openReplayTracker?.setMetadata("email", metadata.email);
  openReplayTracker?.setMetadata("roles", metadata.roles);
}

export function initOpenReplay(config: AppConfig, userId: string): void {
  if (openReplayTracker !== null) {
    return;
  }

  const settings = readOpenReplaySettings(config);
  if (settings === null) {
    return;
  }

  try {
    openReplayTracker = new Tracker({
      projectKey: settings.projectKey,
      ingestPoint: settings.ingestPoint,
      canvas: { disableCanvas: true },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return;
  }

  openReplayTracker
    .start({ userID: userId, forceNew: true })
    .then((session) => {
      if (!session.success) {
        // eslint-disable-next-line no-console
        console.error(session.reason);
        return;
      }
      isOpenReplayStarted = true;
      sendOpenReplayMetadata();
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
    });
}

export function setOpenReplayMetadata({
  email,
  roles,
}: OpenReplayUserMetadata): void {
  latestOpenReplayMetadata = { email, roles };
  sendOpenReplayMetadata();
}

export function recordOpenReplayError(error: Error): void {
  openReplayTracker?.handleError(error);
}
